<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="shadow-btm">
          <div class="row col-lg-6 col-sm-6 my-auto">
            <h4 class="mb-0 lg-bld">Manage Geographical</h4>
          </div>
        </div>
        <div
          class="page-content"
          v-show="accessObject?.is_view == 1 || !isShowAccessDeniedMessage"
        >
          <div class="card-body py-0 px-2">
            <ul class="nav nav-pills">
              <li class="nav-item cursor-pointer">
                <a
                  class="nav-link"
                  data-toggle="tab"
                  :class="{ active: currentTab == 'STATE' }"
                  v-on:click="changeTab('STATE')"
                >
                  <span>State</span></a
                >
              </li>
              <li class="nav-item cursor-pointer">
                <a
                  class="nav-link"
                  data-toggle="tab"
                  v-on:click="$router.push('/district')"
                >
                  <span>District</span></a
                >
              </li>
              <li class="nav-item cursor-pointer">
                <a
                  class="nav-link"
                  data-toggle="tab"
                  v-on:click="$router.push('/city')"
                >
                  <span>Taluka</span></a
                >
              </li>
              <li class="nav-item cursor-pointer">
                <a
                  class="nav-link"
                  data-toggle="tab"
                  v-on:click="$router.push('/work-location')"
                >
                  <span>Work Location</span></a
                >
              </li>
            </ul>
            <div class="row mt-3">
              <div class="col-lg-6 col-sm-6 form-group row">
                <div class="has-search ml-3">
                  <i
                    class="fa fa-search"
                    style="position: absolute; margin: 10px"
                    aria-hidden="true"
                  ></i>
                  <input
                    type="text"
                    class="form-control"
                    v-on:keyup.enter="getList(0)"
                    placeholder="Search"
                    v-model="searchObj.keyword"
                  />
                </div>
                <a
                  class="fill-btn btn-style cursor-pointer ml-3"
                  v-on:click="getList(0)"
                  >Search</a
                >
                <a
                  class="fill-btn btn-style cursor-pointer"
                  v-on:click="resetFilter()"
                  v-show="searchObj.keyword"
                  >Reset</a
                >
              </div>
              <div
                style="cursor: pointer"
                class="col-lg-6 col-sm-6 txt-right form-group"
              >
                <a
                  v-show="accessObject?.is_add == 1"
                  class="fill-btn cursor-pointer"
                  
                  v-on:click="showAddStatePopup()"
                  >+ Add</a
                >
              </div>
            </div>
            <div class="card border mb-0 radius-15">
              <div class="card-body p-0 pb-4">
                <div class="table-responsive">
                  <div class="dataTables_wrapper dt-bootstrap4">
                    <table
                      class="table table-striped table-bordered dataTable"
                      style="width: 100%"
                      role="grid"
                      aria-describedby="example_info"
                    >
                      <thead>
                        <tr role="row">
                          <th>Sr. No.</th>
                          <th
                            class="sorting"
                            id="id-country_name"
                            v-on:click="
                              sorting('country_name', 'id-country_name')
                            "
                          >
                            Country Name
                          </th>
                          <th
                            class="sorting"
                            id="id-name"
                            v-on:click="sorting('name', 'id-name')"
                          >
                            State Name
                          </th>
                          <th
                            v-show="
                              accessObject?.is_edit == 1 ||
                              accessObject?.is_delete == 1
                            "
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody v-show="!loader">
                        <tr v-for="(data, index) in list" :key="index">
                          <td style="text-align: left">{{ index + 1 }}</td>
                          <td style="text-align: left">
                            {{ data.country_name ? data.country_name : "-" }}
                          </td>
                          <td style="text-align: left">
                            {{ data.name ? data.name : "-" }}
                          </td>
                          <td  v-show="
                              accessObject?.is_edit == 1 ||
                              accessObject?.is_delete == 1
                            ">
                            <a
                              v-show="accessObject?.is_edit == 1"
                              class="fill-btn btn-style cursor-pointer"
                              v-on:click="showUpdateStatePopup(index)"
                              >Edit</a
                            >
                            <a
                              v-show="accessObject?.is_delete == 1"
                              class="fill-btn btn-style cursor-pointer"
                              v-on:click="showDeletePopup(data)"
                              >Delete</a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row mx-0 mb-4">
                  <div class="col-lg-12 mt-5 text-center">
                    <div class="page-bottom-pagination text-right">
                      <Pagination
                        @page-change="pageChange"
                        @items-per-page-change="itemsPerPageChange"
                        ref="listPagination"
                      />
                    </div>
                  </div>
                </div>
                <ErrorComponent @retry="getList(0)" ref="errorComponent" />
              </div>
            </div>
            <TextModal ref="textModal">
              <div class="modal-header">
                <h5 class="modal-title">
                  {{ detail.uuid ? "Edit" : "Add" }} State
                </h5>
                <button
                  type="button"
                  class="close"
                  v-on:click="$refs.textModal.closeModal"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <Form ref="stateForm" @submit="save">
                <div class="modal-body">
                  <div class="form-group">
                    <label for="inputRole">Country</label>
                    <span class="text-danger">*</span>
                    <Field
                      as="select"
                      class="form-control"
                      id="inputRole"
                      name="name_country"
                      v-model="detail.country_id"
                      rules="required:country"
                    >
                      <option value="" disabled>Select Country</option>
                      <option
                        v-for="(data, index) in countryList"
                        :key="index"
                        :value="data.uuid"
                      >
                        {{ data.name }}
                      </option>
                    </Field>
                    <ErrorMessage name="name_country" class="text-danger" />
                  </div>
                  <div class="">
                    <div class="form-group">
                      <label>State</label>
                      <span class="text-danger">*</span>
                      <Field
                        type="text"
                        class="form-control"
                        name="state"
                        v-model="detail.name"
                        placeholder="State"
                        rules="required:state"
                        :validateOnInput="true"
                      />
                      <ErrorMessage name="state" class="text-danger" />
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button class="fill-btn" id="save-button">Save</button>
                  <button
                    type="button"
                    class="fil-btn"
                    id="cancel-button"
                    v-on:click="$refs.textModal.closeModal"
                  >
                    Cancel
                  </button>
                </div>
              </Form>
            </TextModal>
          </div>
        </div>
        <div
          class="text-center"
          style="margin-top: 20%"
          v-show="accessObject?.is_view == 0 || isShowAccessDeniedMessage"
        >
          <h3>You do not have access to view geographical</h3>
        </div>
      </div>
    </div>
    <DeleteModal @remove="deleteRecord($event)" ref="deleteModal" />
  </div>
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
import { Form, Field, ErrorMessage } from "vee-validate";
import DeleteModal from "@/components/DeleteModal";
import TextModal from "@/components/TextModal";
import Pagination from "@/components/Pagination";
export default {
  name: "Geographical",
  components: {
    ErrorComponent,
    Pagination,
    TextModal,
    Form,
    Field,
    ErrorMessage,
    DeleteModal,
  },
  data() {
    return {
      accessObject: this.$helperService.getAccessLevel("Manage Geographical"),
      loader: true,
      isShowAccessDeniedMessage: false,
      type: this.$route.query.type,
      currentTab: "STATE",
      list: [],
      countryList: [],
      stateList: [],
      offset: -1,
      searchObj: {
        offset: "",
        keyword: "",
      },
      detail: {
        uuid: "",
        country_id: "",
        state_id: "",
      },
    };
  },
  mounted() {
    // if (!this.accessObject) {
    //   this.isShowAccessDeniedMessage = true;
    //   this.$router.push("/access-denied");
    //   return;
    // }
    this.$helperService.showMenu("true");
    this.getCountryList();
    this.getList(0);
  },
  methods: {
    getCountryList() {
      this.$api
        .getAPI({
          _action: "/country/list",
        })
        .then((res) => {
          this.countryList = res;
          if (this.detail.country_id != null) {
            this.country_id = this.detail.country_id;
          }
        })
        .catch(() => {});
    },
    changeTab(tab) {
      this.currentTab = tab;
      this.searchObj.keyword = "";
      this.getList(0);
    },
    //  getStateList() {
    //   var obj = {
    //     state_id: this.detail.state_id,
    //   };
    //   this.$api
    //     .getAPI({
    //       _action: "/state/list",
    //       _body: obj,
    //     })
    //     .then((res) => {
    //       this.stateList = res;
    //       if (this.detail.state_id != null) {
    //         this.state_id = this.detail.state_id;
    //       }
    //     })
    //     .catch(() => { });
    // },
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    getList(page, orderBy, sortBy) {
      this.loader = true;
      if (this.$refs.errorComponent) {
        this.$refs.errorComponent.updateListLoader(true);
      }
      this.list = [];
      this.searchObj.offset = page;
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      this.$api
        .getAPI({
          _action: "/state/pagination/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.list = res.list;
          this.offset = res.next_offset;
          this.accessObject = this.$helperService.getAccessLevel(
            "Manage Geographical"
          );
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "State Not Available");
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },

    sorting(sortBy, id) {
      var obj = this.$helperService.sorting(sortBy, id);
      this.getList(0, obj.order_by, obj.sort_by);
    },
    resetFilter() {
      this.searchObj.keyword = "";
      this.getList(0);
    },
    showAddStatePopup() {
      this.detail.uuid = "";
      this.$refs.stateForm.resetForm();
      this.$refs.textModal.showModal();
    },
    showUpdateStatePopup(index) {
      this.detail = {};
      this.detail.name = this.list[index].name;
      this.detail.uuid = this.list[index].uuid;
      this.$refs.textModal.showModal();
      if (this.detail.uuid) {
        this.getDetail();
      }
    },
    save() {
      if (this.detail.uuid) {
        this.$api
          .putAPI({
            _action: "/state",
            _body: this.detail,
            _buttonId: "save-button",
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.$refs.textModal.closeModal();
            this.getList(this.searchObj.offset);
          })
          .catch(() => {});
      } else {
        this.$api
          .postAPI({
            _action: "/state",
            _body: this.detail,
            _buttonId: "save-button",
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.$refs.textModal.closeModal();
           this.getList(0);
          })
          .catch(() => {});
      }
    },
    showDeletePopup(data) {
      this.$refs.deleteModal.showModal(
        "Delete State",
        "Are you sure you want to delete " + data.name,
        data
      );
    },
    deleteRecord(dataObj) {
      var detail = new Proxy(dataObj, {});
      var obj = {};
      obj.uuid = detail.uuid;
      obj.status = "DELETED";
      this.$api
        .putAPI({
          _action: "/state/delete/" + detail.uuid,
          _body: obj,
        })
        .then((res) => {
          if (res) {
            this.$refs.deleteModal.closeModal();
            this.getList(0);
            this.$notify({
              type: "success",
              text: "State deleted successfully",
            });
          }
        })
        .catch(() => {
          this.$refs.deleteModal.removeLoader();
        });
    },

    getDetail() {
      this.$api
        .getAPI({
          _action: "/state/detail/" + this.detail.uuid,
        })
        .then((res) => {
          this.detail = res;
          // this.backgroundImage = this.details.background_image
          this.$refs.textModal.showModal();
        })
        .catch(() => {});
    },
  },
};
</script>
